import { useLocation, useParams } from 'react-router-dom';

import BillingCatalog from '../../features/billing/layouts/catalog';
import BatchDetail from '../../features/billing/layouts/batch-detail';

// TSS vite/01 §"Pages are thin". /admin/billing — Facturación · Catálogo (Capa 5).
// /admin/billing/liquidations/:id — detalle de una liquidación mensual (página, no modal).
export default function BillingPage() {
    const { id } = useParams();
    const { pathname } = useLocation();

    if (id && pathname.includes('/liquidations/')) return <BatchDetail batchId={id} />;
    return <BillingCatalog />;
}
